import { SelectedShippingRateSchema } from "@redotech/redo-model/fulfillments/fulfillment-carriers-and-services";
import * as z from "zod";

export const BuyRequestSchema = z.object({
  fulfillmentGroupId: z.string(),
  lineItems: z.array(z.object({ id: z.string(), quantity: z.number() })),
  shipmentRate: SelectedShippingRateSchema,
});
export type BuyRequest = z.infer<typeof BuyRequestSchema>;

export const BuyResponseSchema = z.object({
  success: z.boolean(),
  errorMessage: z.string().nullish(),
});
export type BuyResponse = z.infer<typeof BuyResponseSchema>;

export const buyLabels = {
  name: "buyLabels" as const,
  input: z.object({
    buyRequests: z.array(BuyRequestSchema),
    userId: z.string(),
    print: z.boolean(),
    templateId: z.string().nullish(),
    fulfillmentDate: z.date().nullish(),
    notifyMarketplace: z.boolean().nullish(),
    initiationTime: z.number().nullish(),
  }),
  output: z.object({ batchId: z.string(), batchNumber: z.string() }),
};
